import EnumItem from '../../../common/utils/Enum'
import { i18n } from '../../../common/utils/i18n'

export default new EnumItem({
  NO: {
    text: i18n.gettext('不限'),
    value: 0
  },
  YES: {
    text: i18n.gettext('指定'),
    value: 1
  }
})